<ng-content></ng-content>
@if (status === 'none') {
  <se-fe-icon
    seFeDataName="caret_up_down"
    seFeDataSize="200"
    seFeDataMargin="false">
  </se-fe-icon>
}
@if (status === 'asc') {
  <se-fe-icon
    seFeDataName="caret_up"
    seFeDataSize="300"
    seFeDataMargin="false">
  </se-fe-icon>
}
@if (status === 'desc') {
  <se-fe-icon
    seFeDataName="caret_down"
    seFeDataSize="300"
    seFeDataMargin="false">
  </se-fe-icon>
}
